import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20cat%20sitting%20on%20a%20velvet%20armchair%20in%20a%20warm%20classic%20library%2C%20soft%20golden%20light%20streaming%20through%20window%2C%20bookshelves%20background%2C%20vintage%20atmosphere%2C%20refined%20gentleman%20study%2C%20photorealistic%20editorial%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="喵绅士 - 高雅猫咪文化与精品生活方式"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <div className="max-w-3xl w-full">
          <p className="font-accent text-base md:text-lg italic text-white/70 mb-3 tracking-wider">
            Mr. Meow
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4 md:mb-6">
            喵绅士
          </h1>
          <p className="text-sm md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto mb-8 md:mb-10">
            高雅猫咪文化与精品生活方式 —— 汇聚猫咪文化、绅士美学与精致生活，
            让每一位爱猫人都能活得像一位真正的喵绅士
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/cat-culture"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              探索喵绅士
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
            >
              了解品牌故事
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}